import { useRouter } from "next/router";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { submitLoginForm } from "../../api/login";
import { postMember } from "../../api/members";
import { failAlert, successAlert } from "../../common/alert";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../redux/action/confirm";
import { isLoaded, isLoading } from "../../redux/action/loading";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    position: fixed;
    top: 10%;
    left: 35vw;
    width: 30vw;
    height: auto;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 991px) {
      left: 25vw;
      width: 50vw;
    }
    @media screen and (max-width: 767px) {
      left: 10vw;
      width: 80vw;
    }
  }

  .header {
    display: flex;
    padding: 10px 10px;
    & img {
      margin-left: auto;
      width: 35px;
      cursor: pointer;
    }
  }
  .title {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    & h4 {
      color: #3bb77e;
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    & > span {
      color: black;
    }
  }

  .inputWrapper {
    width: 100%;
    margin-bottom: 20px;
    & h6 {
      margin-bottom: 10px;
    }
    & input {
      height: 38px;
      margin-bottom: 10px;
      ::placeholder {
        font-size: 14px;
        color: #6c757da5;
      }
      :focus {
        border-color: #3bb77e !important;
        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
      }
    }
    .col {
      display: flex;
      flex-direction: column;
      width: 50%;
      & input {
        width: 100%;
        padding-right: 0;
      }
    }
    .row {
      display: flex;
      flex-direction: column;
      .col {
        width: 100%;
      }
    }
  }

  & textarea {
    min-height: 150px;
    ::placeholder {
      font-size: 14px;
      color: #6c757da5;
    }
    :focus {
      border-color: #3bb77e !important;
      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
    }
  }
  .btnWrapper {
    width: 100%;
    & button {
      width: 100%;
    }
  }

  .checkboxWrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
    margin-bottom: 20px;
    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .designCheck {
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
  }
`;

const QuickSignUpModal = ({
  info,
  onClickQuickSignUp,
  ordernum,
  modifyConfirmModal,
  openConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
}) => {
  const router = useRouter();
  const [userInputs, setUserInputs] = useState({});

  const onChangeUserInputs = (e) => {
    setUserInputs({
      ...userInputs,
      [e.target.id]: e.target.value,
    });
  };

  const submitSignUp = async () => {
    const content = {
      title: "가입하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onClose: () => closeConfirmModal(),
      onAction: async () => {
        isLoading();
        const body = {
          modes: "FastJoin",
          uid: userInputs.uid,
          upass: userInputs.upass,
          reupass: userInputs.reupass,
          ordernum: ordernum ? ordernum : "",
        };
        if (
          Object.values(body).includes(null) ||
          Object.values(body).includes(undefined)
        ) {
          failAlert("내용을 모두 입력해주세요.");
          isLoaded();
          return;
        }
        const res = await postMember(body);

        if (res?.Code === "0000") {
          closeConfirmModal();
          globalThis.dataLayer.push({ event: "3second_Sign_up" });
          successAlert(res?.Data?.Msg ? res?.Data?.Msg : "가입되었습니다!");

          const loginBody = {
            modes: "Login",
            uid: userInputs.uid,
            upass: userInputs.upass,
          };

          const loginRes = await submitLoginForm(loginBody, false);
          if (loginRes === "Success") {
            onClickQuickSignUp();
            router.reload();
            isLoaded();
          }
        } else {
          failAlert(res?.Data?.Msg ? res?.Data?.Msg : "회원가입 실패");
          closeConfirmModal();
          isLoaded();
        }
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="header">
            <img
              src="/assets/imgs/page/common/modal_close_icon.png"
              alt="modal_close_icon"
              onClick={onClickQuickSignUp}
            />
          </div>
          <div className="title">
            <h4>주문정보로 회원 가입</h4>
          </div>
          <div className="modal-content">
            <div className="inputWrapper">
              <div className="row">
                <div className="col">
                  <h6>아이디</h6>
                  <input type="text" id="uid" onChange={onChangeUserInputs} />
                </div>
                <div className="col">
                  <h6>비밀번호</h6>
                  <input
                    type="password"
                    autoComplete="new-password"
                    id="upass"
                    onChange={onChangeUserInputs}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>비밀번호 확인</h6>
                  <input
                    type="password"
                    autoComplete="new-password"
                    id="reupass"
                    onChange={onChangeUserInputs}
                  />
                </div>
              </div>
            </div>
            <div className="btnWrapper">
              <button className="btn" onClick={submitSignUp}>
                가입하기
              </button>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
};

export default connect(null, mapDispatchToProps)(QuickSignUpModal);
